import { render, staticRenderFns } from "./myHaggle.vue?vue&type=template&id=9f531fae&scoped=true&"
import script from "./myHaggle.vue?vue&type=script&lang=js&"
export * from "./myHaggle.vue?vue&type=script&lang=js&"
import style0 from "./myHaggle.vue?vue&type=style&index=0&id=9f531fae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f531fae",
  null
  
)

export default component.exports